var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('br'),_c('br'),_c('H4',[_c('li',[_vm._v("שמפו מוצק בהתאמה אישיות 50 ₪")])]),_c('H4',[_c('li',[_vm._v("מרכך מוצק 55 ₪")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }